import Papa from "papaparse";
import { useEffect, useRef, useState } from "react";
import axios from 'axios';
import moment from 'moment';
import { KTIcon } from "../../../_metronic/helpers";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { AccountImportExportMapping } from "./AccountImportExportMapping";
import { ShowSwal } from "../../../common/SweetAlert";
import { Console } from "console";
import { CSVDownload, CSVLink } from "react-csv";
import { getDataTableForExportAsync,setisImportExport } from "./importExportSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { ShowToast } from "../../../common/Toastr";
import DatePicker from 'react-datepicker';
import { useTranslation } from "react-i18next";
import Loader from '../../../common/Loader';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';


export const AccountImportExport = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [csvData, setCsvData] = useState(null);
  const { ImportExportList, fileName, isLoading, selectedRecord, isImportExport } = useAppSelector((state) => state.importExport);
  const { maxMenuHeight,sessionAccountId, CurrentCultureDateFormat, calendarStartDay } = useAppSelector((state) => state.globalState);
  const [showCurrentComponent, setShowCurrentComponent] = useState(true);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [dataSourceArray, SetDataSourceArray] = useState<any | ''>([]);
  const [selectedOptionDataSource, setSelectedOptionDS] = useState<{ [object: string]: any }>();
  const [employeeArray, SetEmployeeeArray] = useState<any | ''>([]);
  const [selectedOptionEmployees, setSelectedOptionEmployees] = useState<{ [object: string]: any }>({ value: '-1', label: 'All' });
  const [projectArray, setProjectArray] = useState<any | ''>([]);
  const [selectedOptionProject, setSelectedOptionProject] = useState<{ [object: string]: any }>({ value: '-1', label: 'All' });
  const [locationArray, setLocationArray] = useState<any | ''>([]);
  const [selectedOptionLocation, setSelectedOptionLocation] = useState<{ [object: string]: any }>({ value: '-1', label: 'All' });
  const [workTypeArray, SetWorkTypeArray] = useState<any | ''>([]);
  const [selectedOptionWorkTypes, setSelectedOptionWorkTypes] = useState<{ [object: string]: any }>({ value: '-1', label: 'All' });
  const currentDate = new Date();
  const [SelectedStartDate, setSelectedStartDate] = useState(currentDate);
  const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
  const [isDatePickerEnabled, setIsDatePickerEnabled] = useState(true);
  const [selectedOptionImportExport, setSelectedOptionImportExport] = useState('Export');
  const [selectedFileType, setSelectedFileType] = useState('CSV');
  const [selectedBillingType, setSelectedBillingType] = useState('Both');
  const [billingType, setBillingType] =  useState<any>('= IsBillable');
  const [selectedApprovedType, setSelectedApprovedType] = useState('Both');
  const [approvedType, setApprovedType] = useState("= Approved");
  const [SelectedExportData, setSelectedExportData] = useState('');
  const [SelectedFileName, setSelectedFileName] = useState('');
  const [SelectedColumnHeaders, setSelectedColumnHeaders] = useState<any | ''>([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const csvLinkRef = useRef<any>();
  const [isDataSourceSelected, setIsDataSourceSelected] = useState(false)
    const [isShowAddImport, setIsShowAddImport]=useState(false);

  const [TableName, SetTableName] = useState('');
  const [dbTable, SetdbTable] = useState('');
  const [table, SetTable] = useState('');
  const handleOptionChange = (event: any) => {
    setSelectedOptionImportExport(event);
  };

    const getLicenseActivation=async()=>{
        try {
            const response = await fetchAPI('api/v2/LicenseActivation/PageLoad', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            if(response?.status === 200){
                const json = await response.json();
                const allowedEmployee = json?.rowscount >= json?.numberOfUsersAllowed;
                setIsShowAddImport(allowedEmployee);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{
        getLicenseActivation();
    },[isImportExport])

  const getDataSource = async () => {
    const response = await fetchAPI('api/v2/ImportExport/GetAllExportableDatasource/' + false, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
    const json = await response.json();
    const formattedData = json.Data.map((item: any) => ({
      value: `${item.PrimaryKey}_${item.DataName}`, // Create a unique value
      label: item.DataName,
      originalValue: item.PrimaryKey,
      TableName:item.TableName, 
    }));

    SetDataSourceArray(formattedData);
    // json.Data.map((item: any) => {
    //   item.value = item.PrimaryKey;
    //   item.label = item.DataName;
    //   delete item.PrimaryKey;
    //   delete item.DataName;
    // });
    // SetDataSourceArray(json.Data);
  }

  const getProjects = async () => {
    const response = await fetchAPI('api/v2/ImportExport/GetAccountProjectsByAccountId', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
    const json = await response.json();
    json.Data.map((item: any) => {
      item.value = item.AccountProjectId;
      item.label = item.ProjectName;
      delete item.AccountProjectId;
      delete item.ProjectName;
    });
    json.Data.unshift({ value: '-1', label: 'All' })
    setProjectArray(json.Data);
  }

  const getEmployeesForBillingRate = async () => {
    const response = await fetchAPI('api/v2/ImportExport/GetAllEmployeeForBillingRate', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
    const json = await response.json();
    json.Data.map((item: any) => {
      item.value = item.AccountEmployeeId;
      item.label = item.EmployeeName;
      delete item.AccountEmployeeId;
      delete item.EmployeeName;
    });
    json.Data.unshift({ value: '-1', label: 'All' })
    SetEmployeeeArray(json.Data);
  }

  const getLocations = async () => {
    const response = await fetchAPI('api/v2/ImportExport/GetAccountLocationsByAccountId', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
    const json = await response.json();
    json.Data.map((item: any) => {
      item.value = item.AccountLocationId;
      item.label = item.AccountLocation;
      delete item.AccountLocationId;
      delete item.AccountLocation;
    });
    json.Data.unshift({ value: '-1', label: 'All' })
    setLocationArray(json.Data);
  }

  const getWorkTypeForBillingRate = async () => {
    const response = await fetchAPI('api/v2/ImportExport/GetAccountWorkTypesForBillingRate', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
    const json = await response.json();
    json.Data.map((item: any) => {
      item.value = item.AccountWorkTypeId;
      item.label = item.AccountWorkType;
      delete item.AccountWorkTypeId;
      delete item.AccountWorkType;
    });
    json.Data.unshift({ value: '-1', label: 'All' })
    SetWorkTypeArray(json.Data);
  }


  // useEffect(() => {
  //   let stateItem: any = {}
   
  //   if (Object.keys(selectedRecord).length > 0) {
  //     console.log('selectedRecord',selectedRecord)
  //     const ExportColumnHeaders = ImportExportList.length > 0 ? Object.keys(ImportExportList[0]) : [];
  //   }

  // }, [selectedRecord])

  useEffect(() => {
    getDataSource();
    getProjects();
    getLocations();
    getEmployeesForBillingRate();
    getWorkTypeForBillingRate();
  }, [])

  const handleChangeFileType = (event: any) => {
    setSelectedFileType(event);
  };

  const handleChangeDataSource = (selectedOptionDataSource: any) => {
    dispatch(setisImportExport(false));

    const originalPrimaryKey = selectedOptionDataSource.originalValue;
    setSelectedOptionDS({ value: selectedOptionDataSource.value, label: selectedOptionDataSource.label });
    SetTableName(selectedOptionDataSource.label);
    SetdbTable(selectedOptionDataSource.TableName);
    SetTable(selectedOptionDataSource.label);
    setIsDataSourceSelected(selectedOptionDataSource.originalValue !== null && selectedOptionDataSource.originalValue !== undefined)
  };


  
  const handleChange = (event:any) => {
    const { checked } = event.target;
    setIsUpdate(checked); 
  };

  useEffect(() => {
    if (SelectedFileName) {
      if (csvLinkRef.current) {
        csvLinkRef.current.link.click();
      }
    }

  }, [SelectedFileName])


  useEffect(() => {
    setShowCurrentComponent(true)
    setShowOtherComponent(false)
    setIsUpdate(false);
  }, [isImportExport])


  // const handleOnClickEvent = () => {

  //   const AccountEmployeeId = selectedOptionEmployees === null || selectedOptionEmployees === undefined ? -1 : selectedOptionEmployees.value;
  //   const AccountWorkTypeId = selectedOptionWorkTypes === null || selectedOptionWorkTypes === undefined ? -1 : selectedOptionWorkTypes.value;
  //   const AccountProjectId = selectedOptionProject === null || selectedOptionProject === undefined ? -1 : selectedOptionProject.value;
  //   const AccountLocationId = selectedOptionLocation === null || selectedOptionLocation === undefined ? -1 : selectedOptionLocation.value;
  //   const StartDate = moment(SelectedStartDate).format('YYYY-MM-DD')
  //   const EndDate = moment(SelectedEndDate).format('YYYY-MM-DD')
    
  //   console.log('AccountEmployeeId', AccountEmployeeId)

  //   if (selectedOptionImportExport === 'Export' || selectedOptionImportExport === 'Import') {
  //     if (selectedOptionDataSource === null || selectedOptionDataSource === undefined) {
  //       ShowSwal(t('ATTENTION PLEASE'), (t("Before Proceed! You have to must select Data Source")), 'warning');
  //     } else {
  //       if (selectedFileType === 'CSV') {
  //         if (selectedOptionImportExport === 'Export') {
  //           dispatch(getDataTableForExportAsync({
  //             TableName: TableName,
  //             AccountEmployeeId: AccountEmployeeId,
  //             AccountProjectId: AccountProjectId,
  //             AccountWorkTypeId: AccountWorkTypeId,
  //             StartDate: StartDate,
  //             EndDate: EndDate
  //           }))
  //             .unwrap()
  //             .then((originalPromiseResult) => {
  //               const data = originalPromiseResult.data;
  //               if (data !== undefined){
  //                 setSelectedColumnHeaders(data.length > 0 ? Object.keys(data[0]) : []);
  //                 setSelectedExportData(originalPromiseResult.data);
  //                 setSelectedFileName(originalPromiseResult.FileName);
  //               }               
  //             })
  //             .catch((rejectedValueOrSerializedError) => {
  //               ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
  //             })
  //         }
  //         else {
  //           if (csvData !== null) {
  //             setShowCurrentComponent(false);
  //             setShowOtherComponent(true);
  //           } else {
  //             ShowSwal('No records found!', "Please Attach CSV with data.", "warning");
  //           }

  //         }
  //       } else {
  //         ShowSwal('No records found!', "", "warning");
  //       }

  //     }
  //   }
  // }
  const handleOnClickEvent = () => {
    const AccountEmployeeId = selectedOptionEmployees === null || selectedOptionEmployees === undefined ? -1 : selectedOptionEmployees.value;
    const AccountWorkTypeId = selectedOptionWorkTypes === null || selectedOptionWorkTypes === undefined ? -1 : selectedOptionWorkTypes.value;
    const AccountProjectId = selectedOptionProject === null || selectedOptionProject === undefined ? -1 : selectedOptionProject.value;
    const AccountLocationId = selectedOptionLocation === null || selectedOptionLocation === undefined ? -1 : selectedOptionLocation.value;
    const StartDate = moment(SelectedStartDate).format('YYYY-MM-DD');
    const EndDate = moment(SelectedEndDate).format('YYYY-MM-DD');
    const whereclause = [{ TimeEntryStartDate: StartDate, TimeEntryEndDate: EndDate , IsBillable: billingType, Approved: approvedType , AccountId: sessionAccountId }];

   // const whereclause = `(TimeEntryDate >= ${StartDate}) AND (TimeEntryDate <= ${EndDate}) AND (IsBillable = ${selectedBillingType}) AND (Approved = ${selectedApprovedType}) AND AccountId = ${sessionAccountId}`;  
    if (selectedOptionImportExport === 'Export' || selectedOptionImportExport === 'Import') {
      if (selectedOptionDataSource === null || selectedOptionDataSource === undefined) {
        ShowSwal(t('ATTENTION PLEASE'), 
        // (t("Before Proceed! You have to must select Data Source")),
        (getValueFromResource('Before Proceed! You have to must select Data Source',dispatch, t)), 'warning');
      } else {
        if (selectedFileType === 'CSV') {
          if (selectedOptionImportExport === 'Export') {
            dispatch(getDataTableForExportAsync({
              TableName: TableName,
              AccountEmployeeId: AccountEmployeeId,
              AccountProjectId: AccountProjectId,
              AccountWorkTypeId: AccountWorkTypeId,
              StartDate: StartDate,
              EndDate: EndDate,
              WhereClause: whereclause 
            }))
            .unwrap()
            .then((originalPromiseResult) => {
              const data = originalPromiseResult.data;
              if (data !== undefined && data !== "") {
              
                setSelectedColumnHeaders(data.length > 0 ? Object.keys(data[0]) : []);
              
                const csv = Papa.unparse(data, {
                  quotes: false,
                  delimiter: ',',
                  header: false // Ensure that no header row is included

                });
               
                
                setSelectedExportData(csv);
                setSelectedFileName(originalPromiseResult.FileName);
              }else{
                ShowSwal('No data available for export', "", "warning");
              }
            })
            .catch((rejectedValueOrSerializedError) => {
              ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            });
          } else {
            if (csvData !== null) {
              setShowCurrentComponent(false);
              setShowOtherComponent(true);
            } else {
              ShowSwal('Please Attach CSV with data.', "", "warning");
            }
          }
        } else {
          ShowSwal('No records found!', "", "warning");
        }
      }
    }
  };
  

  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      Papa.parse(file, {
        header: true,
        dynamicTyping: true,
        complete: function (results: any) {
          const dataWithoutNullData = results.data.filter((row: any) => {
            return Object.values(row).some((value) => value !== null);
          });

          if (dataWithoutNullData.length > 0) {
            setCsvData(dataWithoutNullData);
            setSelectedColumnHeaders(dataWithoutNullData.length > 0 ? Object.keys(dataWithoutNullData[0]) : []);
          } else {
            ShowToast('error', `No records found!', There is no row in attached file.`, "error", "toast-top-right");
          }
        },
        error: function (error) {
          console.error("CSV parsing error:", error.message);
        },
      });
    }
  };

  const headers1 = [
    // CSV header names
    { label: 'Name', key: 'name' },
    { label: 'Age', key: 'age' },
    { label: 'City', key: 'city' },
    // Add more headers as needed
  ];

  const data = [
    { name: 'John Doe', age: 30, city: 'New York' },
    { name: 'Jane Smith', age: 25, city: 'San Francisco' },
  ];


  const handleChangeEmployees = (selectedOptionEmployees: any) => {
    setSelectedOptionEmployees({ label: selectedOptionEmployees.label, value: selectedOptionEmployees.value });
  };
  const handleChangeProject = (selectedOptionProject: any) => {
    setSelectedOptionProject({ label: selectedOptionProject.label, value: selectedOptionProject.value });
  };

  const handleChangeWorkType = (selectedOptionWorkTypes: any) => {
    setSelectedOptionWorkTypes({ label: selectedOptionWorkTypes.label, value: selectedOptionWorkTypes.value });
  };

  // const employeeArrayWithZero = [
  //   { value: -1, label: '<All>' }, 
  //   ...employeeArray,
  // ];

  // const workTypeArrayWithZero = [
  //   { value: -1, label: '<All>' }, // You can customize the label as needed
  //   ...workTypeArray,
  // ];

  const handleStartDateChange = (selectedDate: any) => {
    setSelectedStartDate(selectedDate);
  };

  const handleEndDateChange = (selectedDate: any) => {
    setSelectedEndDate(selectedDate);
  };

  const handleChangeLocation = (selectedDate: any) => {
    setSelectedOptionLocation({ label: selectedDate.label, value: selectedDate.value });
  };


  const handleChangeBillingType = (event: any) => {

    if(event === 'Both')
    {
      setSelectedBillingType(event);
      setBillingType('= IsBillable');
    }
    else if (event === 'Billing')
    {
      setSelectedBillingType(event);
      setBillingType('= 1');
    }
    else  if (event === 'Non-Billing')
    {
      setSelectedBillingType(event);
      setBillingType('<> 1 or IsBillable is null');
    }    
    
  };

  const handleChangeApprovedStatus = (event: any) => {
    setSelectedApprovedType(event);
    if(event === 'Both')
      {
        setSelectedApprovedType(event);
        setApprovedType("= Approved");
      }
      else if (event === 'Approved')
      {
        setSelectedApprovedType(event);
        setApprovedType('= 1');
      }
      else  if (event === 'Not Approved')
      {
        setSelectedApprovedType(event);
        setApprovedType('<> 1 or Approved is null');
      }    
  };

  return (
    <>
      {isLoading && <Loader />}
      {showCurrentComponent && (
        <div className="card card-custom admin-card">
         <div className="card-header card-drop sticky-top bg-white fixed-top">
            <h3 className="card-title fw-bold headerTitle"  >
              {/* {t('CSV/QUICKBOOKS(IIF) IMPORT EXPORT')} */}
              {getValueFromResource('CSV/QUICKBOOKS(IIF) IMPORT EXPORT',dispatch, t)}
              </h3>
            <div className="card-toolbar">
              {!(isShowAddImport && !isUpdate && selectedOptionImportExport === 'Import' && selectedOptionDataSource?.label === 'Employee') && (<a id="btnUpdate"
              className={`btn btn-primary btn-sm ${!isDataSourceSelected ? 'disabled' : ''}`}
                // className="btn btn-primary btn-sm"
                onClick={handleOnClickEvent}
              >
                <KTIcon iconName='arrow-right' className='fs-3' />
                 {/* {t('Proceed')} */}
                 {selectedOptionImportExport === 'Export' ? 'Export' : 'Import'} 
                 {/* {getValueFromResource('Proceed',dispatch, t)} */}
                
              </a>)}
            </div>
          </div>

          <div className='card-body'>
            <div className='row mt-6'>
              <div className="col-md-2 mb-2">
                <label className="form-label" > 
                  {/* {t('Import / Export')} */}
                  {getValueFromResource('Import / Export',dispatch, t)}
                </label>
              </div>
              <div className="radio-inline col-md-6 mb-6" >
                <label className="radio radio-lg">
                  <input
                    style={{ marginRight: "2px" }}
                    className="form-check-input"
                    id="Export"
                    type="radio"
                    checked={selectedOptionImportExport === 'Export'}
                    onChange={() => handleOptionChange('Export')}
                  />

                  <label className="form-label ">
                    {/* {t('Export')}  */}
                    {getValueFromResource('Export',dispatch, t)}
                    </label>
                </label>
                <label className="radio radio-lg">
                  <input
                    style={{ marginRight: "2px", marginLeft: "10px" }}
                    className="form-check-input"
                    id="Import"
                    type="radio"
                    checked={selectedOptionImportExport === 'Import'}
                    onChange={() => handleOptionChange('Import')}
                  />

                  <label className="form-label ">
                    {/* {t('Import')} */}
                    {getValueFromResource('Import',dispatch, t)}
                    </label>
                </label>

              </div>

            </div>

            <div className='row'>
              <div className="col-md-2 mb-2">
                <label className="form-label"> 
                  {/* {t('File Type')} */}
                  {getValueFromResource('File Type',dispatch, t)}
                </label>
              </div>


              <div className="radio-inline col-md-6 mb-6" >
                <label className="radio radio-lg">
                  <input
                    style={{ marginRight: "2px" }}
                    className="form-check-input"
                    id="CSV"
                    type="radio"
                    checked={selectedFileType === 'CSV'}
                    onChange={() => handleChangeFileType('CSV')}
                  />

                  <label className="form-label ">
                    {/* {t('CSV')} */}
                    {getValueFromResource('CSV',dispatch, t)}
                    </label>
                </label>
                <label className="radio radio-lg">
                  <input
                    style={{ marginRight: "2px", marginLeft: "25px" }}
                    className="form-check-input"
                    id="Quickbooks"
                    type="radio"
                    checked={selectedFileType === 'Quickbooks'}
                    onChange={() => handleChangeFileType('Quickbooks')}
                  />

                  <label className="form-label ">
                    {/* {t('Quickbooks (IIF)')} */}
                    {getValueFromResource('Quickbooks (IIF)',dispatch, t)}
                    </label>
                </label>
                <label className="radio radio-lg">
                  <input
                    style={{ marginRight: "2px", marginLeft: "10px" }}
                    className="form-check-input"
                    id="MicrosoftProject"
                    type="radio"
                    checked={selectedFileType === 'MicrosoftProject'}
                    onChange={() => handleChangeFileType('MicrosoftProject')}
                  />

                  <label className="form-label "> 
                     {/* {t('Microsoft Project')} */}
                     {getValueFromResource('Microsoft Project',dispatch, t)}
                     </label>
                </label>
              </div>

            </div>
            {(TableName === 'Department' || TableName === 'Projects' || TableName === 'Project Task' || TableName === 'Employee' || TableName === 'Client') && selectedOptionImportExport !== 'Export' && (
              <div className='row'>
                <div className="col-md-2 mb-2">
                  <label className="form-label" style={{ marginTop: "5px" }}> 
                   {/* {t('For Update')} */}
                     {getValueFromResource('For Update',dispatch, t)}
                  </label>
                </div>

                <div className="col-md-1 mb-1">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    {/* <input style={{ marginRight: "2px", marginTop: "-5px" }} className="form-check-input h-20px w-30px" type="checkbox" id="Export" /> */}

                    <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={isUpdate} id="IsDisabled" onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className='row' style={{ marginTop: "2vh" }}>
              <div className="col-md-3 mb-3">
                <label className="form-label">
                   {/* {t('Data Source')} */}
                   {getValueFromResource('Data Source',dispatch, t)}
                </label>
                <Select
                  id="PrimaryKey"
                  className="basic-single"
                  classNamePrefix="select"
                  isSearchable={true}
                  name="PrimaryKey"
                  options={dataSourceArray}
                  styles={dropDownSelectionStyles}
                  maxMenuHeight={maxMenuHeight}
                  onChange={handleChangeDataSource}
                />

              </div>
              {(TableName === 'Time Entry' || TableName === 'Project Task' || TableName === 'Tasks Users' || TableName === 'Projects Team' || TableName === 'Projects Roles') && selectedOptionImportExport === 'Export' && (
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    {/* {'Project'} */}
                    {getValueFromResource('Project',dispatch, t)}
                    </label>
                  <Select
                    value={selectedOptionProject}
                    id="PrimaryKey"
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={true}
                    name="PrimaryKey"
                    options={projectArray}
                    onChange={handleChangeProject}
                    styles={dropDownSelectionStyles}
                    maxMenuHeight={maxMenuHeight}
                  />
                </div>
              )}
            </div>

            <div className='row' style={{ marginTop: "2vh" }}>
              {(TableName === 'Employee Billing Rate' || TableName === 'Expense Entry' || TableName === 'Time Entry' || TableName === 'Time Off' || TableName === 'Time Off Request' || TableName === 'Attendance') && selectedOptionImportExport === 'Export' && (
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    {/* {t('Employee')} */}
                    {getValueFromResource('Employee',dispatch, t)}
                  </label>
                  <Select
                    value={selectedOptionEmployees}
                    id="PrimaryKey"
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={true}
                    name="PrimaryKey"
                    options={employeeArray}
                    styles={dropDownSelectionStyles}
                    maxMenuHeight={maxMenuHeight}
                    onChange={handleChangeEmployees}
                  />
                </div>
              )}


              {TableName === 'Employee Billing Rate' && selectedOptionImportExport === 'Export' && (
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    {/* {'Work Type'} */}
                    {getValueFromResource('Work Type',dispatch, t)}
                    </label>
                  <Select
                    value={selectedOptionWorkTypes}
                    id="PrimaryKey"
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={true}
                    name="PrimaryKey"
                    options={workTypeArray}
                    styles={dropDownSelectionStyles}
                    maxMenuHeight={maxMenuHeight}
                    onChange={handleChangeWorkType}
                  />
                </div>
              )}

              {TableName === 'Time Entry' && selectedOptionImportExport === 'Export' && (
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    {/* {'Location'} */}
                    {getValueFromResource('Location',dispatch, t)}
                    </label>
                  <Select
                    value={selectedOptionLocation}
                    id="PrimaryKey"
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={true}
                    name="PrimaryKey"
                    options={locationArray}
                    styles={dropDownSelectionStyles}
                  maxMenuHeight={maxMenuHeight}
                    onChange={handleChangeLocation}
                  />
                </div>
              )}
            </div>


            {(TableName === 'Employee Billing Rate' || TableName === 'Expense Entry' || TableName === 'Time Entry' || TableName === 'Time Off' || TableName === 'Time Off Request' || TableName === 'Attendance') && selectedOptionImportExport === 'Export' && (
              <div className='row' style={{ marginTop: "2vh" }}>
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    {/* {t('Start Date')} */}
                    {getValueFromResource('Start Date',dispatch, t)}
                  </label>
                  <div className="wrapper">

                  <DatePicker
                    selected={SelectedStartDate}
                    onChange={handleStartDateChange}
                    calendarStartDay={calendarStartDay}
                    // dateFormat="MM/dd/yyyy"
                    dateFormat={CurrentCultureDateFormat.toString()}
                    className="form-control w-452px ps-4 fs-7 fw-normal"
                    disabled={!isDatePickerEnabled}
                  />
                  <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                     {/* {t('End Date')} */}
                     {getValueFromResource('End Date',dispatch, t)}
                  </label>
                  <div className="wrapper">

                  <DatePicker
                    selected={SelectedEndDate}
                    onChange={handleEndDateChange}
                    calendarStartDay={calendarStartDay}
                    // dateFormat="MM/dd/yyyy"
                    dateFormat={CurrentCultureDateFormat.toString()}
                    className="form-control w-452px ps-4 fs-7 fw-normal"
                  />
                  <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                  </div>
                </div>
              </div>
            )}

            {TableName === 'Time Entry' && selectedOptionImportExport === 'Export' && (
              <div className='row mt-4'>

                <div className="col-md-2 mb-2">
                  <label className="form-label">
                     {/* {t('Billing Type')} */}
                     {getValueFromResource('Billing Type',dispatch, t)}
                  </label>
                </div>
                <div className="radio-inline col-md-6 mb-6" >
                  <label className="radio radio-lg">
                    <input
                      style={{ marginRight: "2px" }}
                      className="form-check-input"
                      id="Both"
                      type="radio"
                      checked={selectedBillingType === 'Both'}
                      onChange={() => handleChangeBillingType('Both')}
                    />

                    <label className="form-label ">
                      {/* {t('Both')} */}
                      {getValueFromResource('Both',dispatch, t)}
                      </label>
                  </label>
                  <label className="radio radio-lg">
                    <input
                      style={{ marginRight: "2px", marginLeft: "25px" }}
                      className="form-check-input"
                      id="Billing"
                      type="radio"
                      checked={selectedBillingType === 'Billing'}
                      onChange={() => handleChangeBillingType('Billing')}
                    />

                    <label className="form-label ">
                      {/* {t('Billing')} */}
                      {getValueFromResource('Billing',dispatch, t)}
                      </label>
                  </label>
                  <label className="radio radio-lg">
                    <input
                      style={{ marginRight: "2px", marginLeft: "25px" }}
                      className="form-check-input"
                      id="Non-Billing"
                      type="radio"
                      checked={selectedBillingType === 'Non-Billing'}
                      onChange={() => handleChangeBillingType('Non-Billing')}
                    />

                    <label className="form-label "> 
                       {/* {t('Non-Billing')} */}
                       {getValueFromResource('Non-Billing',dispatch, t)}
                       </label>
                  </label>
                </div>

              </div>
            )}

            {TableName === 'Time Entry' && selectedOptionImportExport === 'Export' && (
              <div className='row'>

                <div className="col-md-2 mb-2">
                  <label className="form-label"> 
                    {/* {t('Approved Status')} */}
                    {getValueFromResource('Approved Status',dispatch, t)}
                  </label>
                </div>
                <div className="radio-inline col-md-6 mb-6" >
                  <label className="radio radio-lg">
                    <input
                      style={{ marginRight: "2px" }}
                      className="form-check-input"
                      id="Both"
                      type="radio"
                      checked={selectedApprovedType === 'Both'}
                      onChange={() => handleChangeApprovedStatus('Both')}
                    />

                    <label className="form-label ">
                      {/* {t('Both')} */}
                      {getValueFromResource('Both',dispatch, t)}
                      </label>
                  </label>
                  <label className="radio radio-lg">
                    <input
                      style={{ marginRight: "2px", marginLeft: "25px" }}
                      className="form-check-input"
                      id="Approved"
                      type="radio"
                      checked={selectedApprovedType === 'Approved'}
                      onChange={() => handleChangeApprovedStatus('Approved')}
                    />

                    <label className="form-label ">
                      {/* {t('Approved')} */}
                      {getValueFromResource('Approved',dispatch, t)}
                      </label>
                  </label>
                  <label className="radio radio-lg">
                    <input
                      style={{ marginRight: "2px", marginLeft: "25px" }}
                      className="form-check-input"
                      id="Not Approved"
                      type="radio"
                      checked={selectedApprovedType === 'Not Approved'}
                      onChange={() => handleChangeApprovedStatus('Not Approved')}
                    />
                    <label className="form-label ">
                        {/* {t('Not Approved')} */}
                        {getValueFromResource('Not Approved',dispatch, t)}
                        </label>
                  </label>
                </div>

              </div>
            )}

            {selectedOptionImportExport !== 'Export' && (
              <div className='row' style={{ marginTop: "2vh" }}>
                <div className="col-md-3 mb-3">
                  <label className="form-label">
                    {/* {t('Upload File')} */}
                    {getValueFromResource('Upload File',dispatch, t)}
                  </label>
                  <div>
                    <input type="file" accept=".csv" onChange={handleFileChange} />
                  </div>
                </div>
              </div>
            )}
          </div>

          <div>
          </div>
        </div>
      )}

      <CSVLink data={SelectedExportData} headers={SelectedColumnHeaders} filename={SelectedFileName} ref={csvLinkRef}  >
              </CSVLink>    
      {showOtherComponent && <AccountImportExportMapping TableName={TableName} csvData={csvData} dbTable={dbTable} Table={table} IsUpdate={isUpdate} headerResponse={ SelectedColumnHeaders }/>}


    </>

  );

};

const colourStyles: StylesConfig = {
  control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

export default AccountImportExport;